import { useOnlineStatus } from '@leagueplatform/web-common';
import { QueryClient } from 'react-query';
import League, { LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import {
  MasonryDriverNodeRenderersRegistry,
  MasonryWSDriverNodeRenderersRegistry,
} from '@leagueplatform/masonry';
import { ActivityStackWidgetV2 } from '@leagueplatform/health-journey';
import { RecentClaimsCardList } from '@leagueplatform/claims';
import { FormCenterCard } from 'components/form-center/form-center-card.component';

interface UseAppReturn {
  // Data
  isOnline: boolean;
  isOffline: boolean;

  // Computed values
  queryClient: QueryClient;

  // Actions
  initializeApp: () => void;
}

export const useApp = (): UseAppReturn => {
  const { isOnline, isOffline } = useOnlineStatus();

  // Initialize query client
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 3,
      },
    },
  });

  const initializeApp = () => {
    // Initialize League route paths
    League.overwriteRoutePaths({
      [LEAGUE_MODULE_NAMES.wallet]: '/benefits',
      [LEAGUE_MODULE_NAMES.healthJourney]: '/messages',
    });

    // Register masonry renderers
    MasonryWSDriverNodeRenderersRegistry.registerRenderer(
      'cigna',
      'cigna_form_center_item',
      FormCenterCard,
    );

    MasonryDriverNodeRenderersRegistry.registerRenderer(
      'health_journey',
      'activity_stack',
      ActivityStackWidgetV2,
    );

    MasonryWSDriverNodeRenderersRegistry.registerRenderer(
      'claims',
      'recent_claims_cards',
      RecentClaimsCardList,
    );
  };

  return {
    // Data
    isOnline,
    isOffline,

    // Computed values
    queryClient,

    // Actions
    initializeApp,
  };
};
